export default __webpack_public_path__ + "static/media/Strap.5b3851d3.png";